module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("訂購紀錄")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datepicker', {
    attrs: {
      "language": "zh",
      "format": "yyyy-MM"
    },
    model: {
      value: (_vm.choosemonth),
      callback: function($$v) {
        _vm.choosemonth = $$v
      },
      expression: "choosemonth"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": this.searchFlag
    },
    on: {
      "click": function($event) {
        _vm.getConsume()
      }
    }
  }, [_vm._v("查詢")])])]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('tbody', _vm._l((this.consume), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.getDetail(row.trans_main_id)
        }
      }
    }, [_vm._v("明細")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.companyname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.t_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.t_point))]), _vm._v(" "), _c('td', [_vm._v("\n                    點數 " + _vm._s(row.sale_cash)), _c('br'), _vm._v("\n                    現金 " + _vm._s(row.receive_cash) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.c_date))]), _vm._v(" "), (row.PositionCode == '999999999' && row.checkstate == 0 && row.ordercheck != 'user_cancel') ? _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.cancel(row.trans_main_id)
        }
      }
    }, [_vm._v("取消")])]) : _c('td')])
  }))]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Fade Modal",
      "show": _vm.fadeModal,
      "effect": "fade",
      "width": "800"
    },
    on: {
      "update:show": function($event) {
        _vm.fadeModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("購物明細")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td', [_vm._v("品名")]), _vm._v(" "), _c('td', [_vm._v("售價")]), _vm._v(" "), _c('td', [_vm._v("點數")]), _vm._v(" "), _c('td', [_vm._v("數量")]), _vm._v(" "), _c('td', [_vm._v("金額小計")]), _vm._v(" "), _c('td', [_vm._v("購買日期")])])]), _vm._v(" "), _c('tbody', _vm._l((this.detail), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(row.product[0].product_title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.sale_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.sale_point))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ordernumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.sale_price * row.ordernumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.c_date))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.fadeModal = false
      }
    }
  }, [_vm._v("關閉")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td', [_vm._v("訂單明細")]), _vm._v(" "), _c('td', [_vm._v("店家")]), _vm._v(" "), _c('td', [_vm._v("售價")]), _vm._v(" "), _c('td', [_vm._v("點數")]), _vm._v(" "), _c('td', [_vm._v("付款方式")]), _vm._v(" "), _c('td', [_vm._v("日期")]), _vm._v(" "), _c('td')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2add4a8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/Order.vue
// module id = 294
// module chunks = 1